import React from 'react';
import { Box, IconButton, InputLabel } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

interface VideoPlayerProps {
  url?: string | null;
  label?: string;
  onEdit?: () => void;
}

type VideoInfo = { platform: 'youtube' | 'vimeo'; id: string } | null;

const VideoPlayer = ({ url, label, onEdit }: VideoPlayerProps) => {
  if (!url) return null;

  const getVideoId = (videoUrl: string): VideoInfo => {
    const youtubeMatch = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    if (youtubeMatch) return { platform: 'youtube', id: youtubeMatch[1] };

    const vimeoMatch = videoUrl.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return { platform: 'vimeo', id: vimeoMatch[1] };

    return null;
  };

  const videoInfo = getVideoId(url);
  if (!videoInfo) return null;

  const embedUrl = videoInfo.platform === 'youtube'
    ? `https://www.youtube.com/embed/${videoInfo.id}`
    : `https://player.vimeo.com/video/${videoInfo.id}`;

  return (
    <Box style={{ width: '100%', marginTop: '16px' }}>
      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <InputLabel style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px', textAlign: 'left' }}>
          {label || 'Video'}
        </InputLabel>
        {onEdit && (
          <IconButton size="small" onClick={onEdit} style={{ padding: '4px' }}>
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Box style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
        <iframe
          title="Product Video"
          src={embedUrl}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </Box>
    </Box>
  );
};

export default VideoPlayer;